import {AssetSolarWithdrawalOptionPutDataTransferObject} from "../../data-transfer-object/asset/AssetSolarWithdrawalOptionPutDataTransferObject"
import {AssetSolarWithdrawalOptionValueObject} from "../../value-object/asset/AssetSolarWithdrawalOptionValueObject"
import {StatePair, useStatePair} from "react-type-extension"
import {DateFormat} from "ts-format-extension"
import {unwrapUndefinedDate, unwrapUndefinedString} from "ts-type-extension"

export type AssetSolarWithdrawalOptionPutState = {
    solarAmount: StatePair<number>
    cashAmount: StatePair<number>
    toDataTransferObject(): AssetSolarWithdrawalOptionPutDataTransferObject
    fromValueObject(vo: AssetSolarWithdrawalOptionValueObject): void
    values(): [number, number]
}

export function useAssetSolarWithdrawalOptionPutState(): AssetSolarWithdrawalOptionPutState {
    return {
        solarAmount: useStatePair<number>(0),
        cashAmount: useStatePair<number>(0),
        toDataTransferObject(): AssetSolarWithdrawalOptionPutDataTransferObject {
            return {
                solarAmount: this.solarAmount.value,
                cashAmount: this.cashAmount.value,
            }
        },
        fromValueObject(vo: AssetSolarWithdrawalOptionValueObject) {
            this.solarAmount.setter(vo.solarAmount)
            this.cashAmount.setter(vo.cashAmount)
        },
        values(): [number, number] {
            return [
                this.solarAmount.value,
                this.cashAmount.value,
            ]
        }
    }
}
